import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { calendarAsPublicQueryKeys } from "./calendarAsPublicQueryKeys";

export function useQueryNextCalendarEventOccurrencesAsPublic({
  api,
}: {
  api: ApiType;
}) {
  return useQuery({
    queryKey: calendarAsPublicQueryKeys.nextEventOccurrences(),
    queryFn: async ({}) => {
      return (
        await api.public.eventApi.calendarEventOccurrences({
          filters: {
            limit: 1,
            dateFrom: DateTime.now().startOf("hour").toISO()!,
            dateTo: DateTime.now().startOf("hour").plus({ years: 1 }).toISO()!,
          },
        })
      ).data;
    },
  });
}
